import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)


//pc端
import layout from '@/components/pc/layout'
import index from '@/components/pc/index'
import about from '@/components/pc/about'
// import relation from '@/components/pc/relation'
import items from '@/components/pc/items'
import details from '@/components/pc/details'
import news from '@/components/pc/news'
import itemnews from '@/components/pc/itemnews'
import webcase from '@/components/pc/webcase'



import pcbanner from '@/components/pc/public/banner'
Vue.component('pcbanner', pcbanner)



// import maps from '@/components/pc/public/maps'


// Vue.component('maps', maps)


//移动端
import move from '@/components/move/move'
import meindex from '@/components/move/index'
import meabout from '@/components/move/about'
import mefwxm from '@/components/move/fwxm'
import mecase from '@/components/move/case'
import mezhy from '@/components/move/zhy'
import menews from '@/components/move/news'
import meus from '@/components/move/us'
import medetails from '@/components/move/details'
import meitems from '@/components/move/items'



import banner from '@/components/move/banner'
import movemap from '@/components/move/map'


Vue.component('banner', banner)
Vue.component('movemap', movemap)



//后台
import adlogin from '@/components/admin/login'
import adindex from '@/components/admin/index'
import admenu from '@/components/admin/menu'
import adcase from '@/components/admin/case'
import adarticle from '@/components/admin/article'
import adchangewpd from '@/components/admin/changepwd'
import leaveword from '@/components/admin/leaveword'
import adheader from '@/components/admin/onepage/header'
import adfooter from '@/components/admin/onepage/footer'
import adoneindex from '@/components/admin/onepage/index'
import adabout from '@/components/admin/onepage/about'
import adrelation from '@/components/admin/onepage/relation'
import keywords from '@/components/admin/keywords'


//404页面未找到
import underfind from '@/components/404'
const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'layout', component: layout ,redirect: "/",children:[
        { path: '/', name: 'index', component: index },
        { path: '/about.html', name: 'about', component: about ,meta: {
          title: '关于我们-石家庄飞天科技'
        }},
        // { path: '/relation', name: 'relation', component: relation },
        { path: '/items/:id', name: 'items', component: items },
        { path: '/itemnews.html', name: 'itemnews', component: itemnews},
        { path: '/details/:id', name: 'details', component: details },
        { path: '/news/:id', name: 'news', component: news,meta: {
          title: '飞天动态'
        } },
        { path: '/webcase/:id', name: 'webcase', component: webcase,meta: {
          title: '客户案例-石家庄飞天科技'
        } },
     ]},
    {
      path: '/move/', name: 'move', component: move, redirect: '/move/index.html', children: [
        { path: 'index.html', name: 'meindex', component: meindex },
        { path: 'fwxm', name: 'mefwxm', component: mefwxm },
        { path: "case.html", name: 'mecase', component: mecase },
        { path: "zhy.html", name: 'mezhy', component: mezhy },
        { path: 'about.html', name: 'meabout', component: meabout },
        { path: 'news/:id', name: 'menews', component: menews },
        { path: 'us.html', name: 'meus', component: meus },
        { path: 'details/:id', name: 'medetails', component: medetails },
        { path: 'items/:id', name: 'meitems', component: meitems },
      ]
    },
    { path: '/admin/', name: 'login', component: adlogin },
    {
      path: '/admin/index', name: 'index', component: adindex, redirect: '/admin/index/case',children: [
        { path: 'menu', name: 'menu', component: admenu },
        { path: 'case', name: 'case', component: adcase },
        { path: 'article', name: 'article', component: adarticle },
        { path: 'changepwd', name: 'changepwd', component: adchangewpd },
        { path: 'header', name: 'header', component: adheader },
        { path: 'footer', name: 'footer', component: adfooter },
        { path: 'index', name: 'index', component: adoneindex },
        { path: 'about', name: 'about', component: adabout },
        { path: 'relation', name: 'relation', component: adrelation },
        { path: 'leaveword', name: 'leaveword', component: leaveword },
        { path: 'keywords', name: 'keywords', component: keywords },
      ]
    },
    {path:'*',name:'404.html',component:underfind}
  ]
})

export default router




// WEBPACK FOOTER //
// ./src/router/index.js